import { FormikProps } from "formik";
import { FieldMetaData } from "../../../../types/SchemaFactory";
import { useMemo } from "react";
import { CountryData } from "country-codes-list";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { getMetaParameterValue } from "../../../../validation-schemas/SchemaFactory";
const countryCodes = require("country-codes-list");

interface PhoneInputProps {
    form: FormikProps<any>;
    name: string;
    meta: FieldMetaData;
    className?: string;
    wrapClassName?: string;
}

function PhoneInput(props: PhoneInputProps) {
    const { t } = useTranslation();
    const codes: string[] = useMemo(
        () => (countryCodes.all() || []).map((item: CountryData) => item.countryCallingCode),
        [countryCodes]
    );

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const input = event.target.value;
        const sanitizedValue = input.replace(/[^\d+]/g, "");

        const matchedCode = "+" + codes.find((code) => sanitizedValue.replace("+", "").startsWith(code));

        if (!matchedCode) {
            props.form.setFieldError(props.name as string, "Invalid phone code");
        } else {
            props.form.setFieldError(props.name as string, "");
        }

        // const formattedValue = sanitizedValue
        //     .replace(/\s+/g, " ")
        //     .replace(new RegExp(`^(${matchedCode.replace("+", "\\+")})(\d{2})`), "$1 $2")
        //     .replace(/(\d{3})(?=\d{3})/, "$1 ")
        //     .replace(/(\d{2})(?=\d{2})/, "$1 ");

        // TODO :: has a trouble with autocomplete in browser
        // const formattedValue = sanitizedValue
        //     .replace(/\s+/g, " ")
        //     .replace(
        //         new RegExp(`^(${matchedCode.replace("+", "\\+")})(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})?$`),
        //         (_, code, first, second, third, fourth, fifth) => {
        //             return [code, first, second, third, fourth, fifth].filter(Boolean).join(" ");
        //         }
        //     );

        props.form.setFieldTouched(props.name as string, true);
        props.form.setFieldValue(props.name as string, sanitizedValue);
    };

    return (
        <input
            type={props.meta.type}
            value={_.get(props.form.values, props.name)}
            min={getMetaParameterValue(props.meta, "min")}
            max={getMetaParameterValue(props.meta, "max")}
            name={props.name}
            placeholder={t(props.meta.placeholderKey)}
            onChange={handleInputChange}
            className={`input ${props.className}`}
        />
    );
}

export default PhoneInput;
